module.exports = __webpack_public_path__ + "heart-twilight.15fbc498b04017ca0894.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/heart-twilight.svg
// module id = ../../../../../src/assets/img/heart-twilight.svg
// module chunks = main